"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.set = exports.view = exports.lensFrom = exports.lens = void 0;
const deep_1 = require("./deep");
const lens = (getter, setter) => ({
    get: (obj) => getter(obj),
    set: (val, obj) => setter(val, (0, deep_1.copy)(obj)),
});
exports.lens = lens;
const lensFrom = (path, split = '.') => {
    let arrAccessor;
    if (typeof path === "string")
        arrAccessor = path.split(split);
    else
        arrAccessor = path;
    const getter = (obj) => arrAccessor.reduce((prev, currA) => prev === null || prev === void 0 ? void 0 : prev[currA], obj);
    const setter = (value, obj) => {
        arrAccessor.reduce((prev, currA, i) => {
            if (prev === undefined)
                return undefined;
            if (i === arrAccessor.length - 1 && prev[currA] !== null)
                prev[currA] = value;
            return prev[currA];
        }, obj);
        return obj;
    };
    return (0, exports.lens)(getter, setter);
};
exports.lensFrom = lensFrom;
const view = (_lens, obj) => _lens.get(obj);
exports.view = view;
const set = (_lens, value, obj) => _lens.set(value, obj);
exports.set = set;
//# sourceMappingURL=lens.js.map